'use client';

import styled from '@emotion/styled';
import { ComponentProps } from 'react';
import { Color } from '../../../../styles/Color';
import { theme } from '../../../../styles/theme';
import { Button, Css, Responsive } from '../../../../ui';

interface ISecondaryNavigationButtonProps
	extends Omit<ComponentProps<typeof Button>, 'type'> {
	icon?: SVGComponent;
}

export default function SecondaryNavigationButton({
	children,
	icon: Icon,
	...props
}: ISecondaryNavigationButtonProps) {
	return (
		<>
			<StyledLink buttonType="secondary" {...props}>
				<ContentWrap>
					{Icon && (
						<Icon
							width={theme.button?.iconSize}
							height={theme.button?.iconSize}
						/>
					)}
					{children && <Label>{children}</Label>}
				</ContentWrap>
			</StyledLink>
		</>
	);
}

const StyledLink = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;

	color: ${Color.PrimaryWhite};
	background: ${Color.HeaderButtonBackground};
	border-radius: ${theme.button?.radius};
	height: fit-content;
	pointer-events: all;

	:hover {
		text-decoration: underline;

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			text-decoration: none;
		}
	}

	&:not([aria-current='page']):hover {
		text-decoration: none;
	}
`;

const ContentWrap = styled.div`
	display: flex;
	align-items: center;
	gap: ${theme.button?.iconSeparator};
	font-weight: 400;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: 0;
		margin: 0;
		width: 100%;
		height: 100%;
		max-width: unset;
		justify-content: center;
	}

	svg {
		flex-shrink: 0;
	}
`;

const Label = styled.p`
	font-weight: 500;
	font-size: ${Css.pxToRem(17)};
	line-height: 1;
	padding-right: ${Css.pxToRem(4)};
	@media (${Responsive.getMediaQueryForBreakpoint('desktop')}) {
		display: none;
	}
`;
